import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-133c297e")
const _hoisted_1 = { class: "area" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Información general", -1)
const _hoisted_3 = { class: "box" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "nombre" }, "Nombre de la empresa *", -1)
const _hoisted_5 = { class: "form-area" }
const _hoisted_6 = {
  key: 0,
  class: "form-error"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Por favor, completa este campo")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "box" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "sector" }, "Sector *", -1)
const _hoisted_12 = { class: "form-area" }
const _hoisted_13 = { class: "list" }
const _hoisted_14 = {
  key: 0,
  class: "form-error"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Por favor, completa este campo")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "logo" }, "Logo de la empresa (.jpeg) *", -1)
const _hoisted_19 = { class: "uploader" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "image-error"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Por favor, coloca una imagen")
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "buttons" }
const _hoisted_26 = { class: "step-button" }
const _hoisted_27 = { class: "step-button" }
const _hoisted_28 = { class: "step-button" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_LogoUploader = _resolveComponent("LogoUploader")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("fieldset", null, [
        _hoisted_2,
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_InputText, {
                class: "box-size",
                placeholder: "Ingresa el nombre de la empresa",
                modelValue: _ctx.v$.name.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.v$.name.$model = $event))
              }, null, 8, ["modelValue"]),
              (_ctx.v$.name.$errors[0]?.$validator == 'required')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.v$.sector.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.sector.$model = $event)),
                  options: _ctx.sectors,
                  id: "dl",
                  optionLabel: "name",
                  optionValue: "value",
                  placeholder: "Seleccionar sector"
                }, null, 8, ["modelValue", "options"])
              ]),
              (_ctx.v$.sector.$errors[0]?.$validator == 'required')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          (_ctx.imageNotUploaded)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "no-image",
                src: require('@/assets/images/noImage.svg'),
                alt: ""
              }, null, 8, _hoisted_20))
            : _createCommentVNode("", true),
          _createVNode(_component_LogoUploader, {
            class: "uploaderElement",
            modelValue: _ctx.formData.logo,
            "onUpdate:modelValue": _ctx.toggleImage,
            fileType: "image/jpeg"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          (_ctx.imageError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_Button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel())),
              label: "Cancelar",
              class: "back-cancel"
            })
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.back())),
              label: "Anterior",
              class: "back-cancel"
            })
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_Button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.next())),
              label: "Continuar",
              class: "next"
            })
          ])
        ])
      ])
    ])
  ]))
}